module.exports = __webpack_public_path__ + "static/sport_low-c43f14e2d1145bd3c006604b328f07c2.mp4";